import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import CustomButton from '../components/styled/CustomButton'
import Calender from '../components/styled/Calender'
import { Alert, Button, Snackbar } from '@mui/material'
import ConfirmReservationModal from './ConfirmReservationModal'
import WaitingForConfirmationModal from './WaitingForConfirmationModal'
import { useState } from 'react'
import moment from 'moment'
import { getDataById } from '../apis/generalApis'
import { ScaleLoader } from 'react-spinners';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  minWidth: '31% !important',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const SelectAvailableDateModal = ({
  handleSelectAvailableDateModal,
  modalOpen = false,
  screenName = '',
  selectedSubService,
  stylist = {},
}) => {
  let user = JSON.parse(localStorage.getItem('user'))
  React.useEffect(() => {
    getStylistAvailability()
  }, [])

  const [stylistAvailability, setStylistAvailability] = useState([])

  const getStylistAvailability = async () => {
    let response
    setIsLoading(true)
    if (selectedSubService?.provider) {
      response = await getDataById('show-all-availabilities', {
        user_id: selectedSubService?.provider?.id,
      })
    } else {
      response = await getDataById('show-all-availabilities', {
        user_id: user?.id,
      })
    }
    setIsLoading(false)
    if (response?.success === true) {
      setStylistAvailability(response?.data)
    }
  }
  const [buttonsActive, setButtonsActive] = React.useState({
    btn1: false,
    btn2: false,
  })
  const [confirmReservationModal, setConfirmReservationModal] = React.useState(
    false,
  )
  const [selectedDate, setSelectedDate] = useState(
    moment(new Date()).format('YYYY-MM-DD'),
  )
  const [availableTimeSlots, setAvailableTimeSlots] = React.useState([])
  const [selectedService, setSelectedService] = React.useState({
    ...selectedSubService,
    date: '',
  })
  const [
    waitingForConfirmationModal,
    setWaitingForConfirmationModal,
  ] = React.useState(false)

  const [selectedTimelot, setSelectedTimelot] = useState('')
  const [isTimeslotSelected, setIsTimeslotSelected] = useState(null)
  const [userAvailability, setUserAvailability] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  React.useEffect(() => {
    showStylistAvailability()
  }, [])

  const showStylistAvailability = async () => {
    setIsLoading(true)
    let result = await getDataById('show-all-availabilities', {
      user_id: user?.id,
    })
    setIsLoading(false)
    if (result?.success === true) {
      setUserAvailability(result?.data)
    }
  }

  React.useEffect(() => {
    // if (modalOpen) {
    let date = moment(new Date()).format('YYYY-MM-DD')
    if (selectedDate) {
      date = selectedDate
    }
    getAvailableTimeSlots({
      stylist_id: selectedSubService?.provider?.id ?? user?.id,
      date,
      service_id: selectedSubService?.id,
    })
    // }
  }, [selectedDate, selectedSubService?.id])

  const getAvailableTimeSlots = async (body) => {
    if (body?.service_id) {
      setIsLoading(true)
      let result = await getDataById('create-timeslot', body)
      setIsLoading(false)
      if (result?.success === true) {
        setAvailableTimeSlots(result?.data)
      } else {
        setAvailableTimeSlots([])
      }
    }
  }

  const handleWaitingForConfirmationModal = () => {
    setWaitingForConfirmationModal((prevState) => !prevState)
    if (modalOpen === true) {
      handleSelectAvailableDateModal(false)
    }
  }

  const handleConfirmReservationModal = () => {
    if (modalOpen) {
      handleSelectAvailableDateModal(false)
    }
    setConfirmReservationModal(!confirmReservationModal)
  }

  return (
    <>
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 1400,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />

      <Modal
        open={modalOpen}
        onClose={() => handleSelectAvailableDateModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-width">
          <div className="text-center select-available-date-modal">
            <h3 className="fs-24 mb-4 fw-bold">Select any available date</h3>
            <Calender
              minDate={new Date()}
              maxDate={new Date(new Date().setDate(new Date().getDate() + 6))}
              setSelectedDate={setSelectedDate}
              stylistAvailability={stylistAvailability}
            />
            <div style={{ maxWidth: '275px', margin: 'auto' }} className="mt-3">
              <p className="fs-16 font-weight-bold mb-2">
                Select any available time slot
              </p>
              {availableTimeSlots?.length === 0 && (
                <p>The stylist is not available on the selected date.</p>
              )}
              {availableTimeSlots &&
                availableTimeSlots?.map((ts, index) => (
                  <Button
                    key={index}
                    disableElevation
                    fullWidth
                    onClick={() => {
                      setButtonsActive((buttonsActive) => ({
                        ...buttonsActive,
                        btn2: !buttonsActive.btn2,
                      }))
                      setSelectedTimelot(ts)
                    }}
                    className={`${
                      ts === selectedTimelot
                        ? 'br-16 mt-2 active'
                        : 'br-16 mt-2 transparent'
                    }`}
                  >
                    {ts}
                  </Button>
                ))}
              {screenName !== 'profile-screen-view-all' && (
                <Button
                  fullWidth
                  disableElevation
                  id="btn-primary-no-shadow"
                  className="pointer mt-4"
                  onClick={handleWaitingForConfirmationModal}
                >
                  Continue
                </Button>
              )}
              {screenName !== 'create-service' && (
                <div
                  className="mt-4 pointer"
                  onClick={() => {
                    if (!selectedTimelot) {
                      setIsTimeslotSelected(true)
                    } else if (selectedTimelot) {
                      setIsTimeslotSelected(false)
                      setSelectedService((prev) => ({
                        ...selectedSubService,
                        time: selectedService,
                      }))
                      if (selectedSubService?.client) {
                        handleConfirmReservationModal()
                      } else {
                        handleWaitingForConfirmationModal()
                      }
                    }
                  }}
                >
                  <Button
                    fullWidth
                    id="btn-primary-no-shadow"
                    className="pointer"
                  >
                    Continue
                  </Button>
                </div>
              )}
            </div>
          </div>
        </Box>
      </Modal>
      <ConfirmReservationModal
        handleConfirmReservationModal={handleConfirmReservationModal}
        modalOpen={confirmReservationModal}
        booking={{
          ...selectedService,
          date: selectedDate,
          time: selectedTimelot,
          timeslot: selectedTimelot,
          start_timeslot: selectedTimelot,
        }}
      />
      <WaitingForConfirmationModal
        handleWaitingForConfirmationModal={handleWaitingForConfirmationModal}
        waitingForConfirmationModal={waitingForConfirmationModal}
        selectedService={{
          ...selectedSubService,
          date: selectedDate,
          timeslot: selectedTimelot,
          start_timeslot: selectedTimelot,
        }}
        stylist={stylist}
      />
      <Snackbar
        open={isTimeslotSelected}
        autoHideDuration={3000}
        onClose={() => setIsTimeslotSelected(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setIsTimeslotSelected(false)}
          severity="error"
          sx={{ width: '100%' }}
        >
          Please select any timeslot to proceed!
        </Alert>
      </Snackbar>
    </>
  )
}

export default SelectAvailableDateModal
